import { Component, signal, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { ContactModalService } from '../../services/contact-modal.service';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterLink, RouterLinkActive, LucideAngularModule, NgOptimizedImage],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly mobileMenuOpen = signal(false);
  private readonly router = inject(Router);
  private readonly contactModalService = inject(ContactModalService);

  toggleMobileMenu(): void {
    this.mobileMenuOpen.update(open => !open);
  }

  openContactModal(): void {
    this.mobileMenuOpen.set(false);
    this.contactModalService.open();
  }

  navigateToProperties(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    
    // Check if we're already on the home page
    if (this.router.url === '/home') {
      // Just scroll to the section
      setTimeout(() => {
        const element = document.getElementById('properties-section');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 50);
    } else {
      // Navigate to home first, then scroll
      this.router.navigate(['/home']).then(() => {
        setTimeout(() => {
          const element = document.getElementById('properties-section');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      });
    }
  }
}
